








import { Component, Mixins, Prop } from "vue-property-decorator";
import { DisableableMixin } from "../../../system/mixins";
import CircleSelectObject from "../objects/CircleSelectObject.vue";
import CircleSelectInputMethodEditor from "../inputMethodEditors/CircleSelectInputMethodEditor.vue";

@Component({
  components: {
    CircleSelectInputMethodEditor,
  }
})
export default class CircleSelectBehaviorEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: CircleSelectObject;
}
